// extracted by mini-css-extract-plugin
module.exports = {"form":"outPatientRegistrationReport_form__1Tw1S","total":"outPatientRegistrationReport_total__12sy4"};